import { gql } from "@/services/httpAdapter";

export const EligibilityFragment = gql`
	fragment EligibilityFields on EligibilityRequirement {
		rules {
			_id
			make
			model
			trim
			status
			rangeType
			startYear
			endYear
			stockExpression
		}
		tiers {
			_id
			from {
				input
				value
			}
			to {
				input
				value
			}
			commissions {
				_id
				from {
					input
					value
				}
				to {
					input
					value
				}
				commission {
					input
					value
				}
			}
		}
		applyTiersRetroactively
		genericValue
		pvrType
		requiredStoreUnits
		requiredPvr
		franchises
		_id
		newVehicles {
			_id
			make
			tiers {
				_id
				from {
					input
					value
				}
				to {
					input
					value
				}
				bonuses {
					_id
					from {
						input
						value
					}
					to {
						input
						value
					}
					bonus {
						input
						value
					}
				}
			}
			evaluationType
		}
		preOwned {
			_id
			make
			tiers {
				_id
				from {
					input
					value
				}
				to {
					input
					value
				}
				bonuses {
					_id
					from {
						input
						value
					}
					to {
						input
						value
					}
					bonus {
						input
						value
					}
				}
			}
			evaluationType
		}
		combined {
			_id
			make
			tiers {
				_id
				from {
					input
					value
				}
				to {
					input
					value
				}
				bonuses {
					_id
					from {
						input
						value
					}
					to {
						input
						value
					}
					bonus {
						input
						value
					}
				}
			}
			evaluationType
		}
		combineFranchises
		globalUnitCounts
		selectedDepartment
		selectedPayType
		selectedOperationCodes {
			_id
			code
			type
			pay
		}
		selectedTimeLapse
		component
	}
`;

export const AwardsFragment = gql`
	fragment AwardsFields on SpiffAwardItem {
		recipient
		commissionCycleId
		payPeriodId
		spiffItem
		spiffSetup
		locationId
		concatRONumbers
		totalAwardsAmount
		awards {
			spiffDate
			spiffEntry
			spiffItemName
			spiffType
			deals {
				stockNumber
				dealNumber
			}
			repairOrders {
				vinNumber
				repairOrderNumber
			}
			reward
			description
		}
	}
`;
